import React, { useCallback } from 'react'
import './ValLabel.css'

export default function ValLabel({val, setEditMode, isLocked, isSuccess}) {      
  const handleClick = useCallback((e) => {
    setEditMode();
  }, [setEditMode]);

  return (
      <div className={`valLabel ${isLocked ? 'valLocked': 'valEditable'} ${isSuccess ? 'valSuccess' : 'valNormal'}`} onClick={handleClick}>
        {val}
      </div>
  )
}
